import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

const ModalStatusFilter = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.filterStatus');
  const onClose = () => {
    closeSingleModal('filterStatus');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle={'Filtro de status'}
      height={'calc(100vh - 70px)'}
      width={'550px'}
      alignment="right"
    >
      <Form.Validity.Status.Filter />
    </Modal>
  );
};

export default ModalStatusFilter;
